@if (!(isLoading$ | async)) {
  <div class="flex flex-col px-12">
    <div class="flex flex-row items-center justify-between">
      <span class="text-base leading-[1]">Latest Activity</span>

      <nz-select nzVariant="borderless" class="w-[120px]" [ngModel]="defaultFilter" (ngModelChange)="changeFilter($event)">
        <nz-option [nzValue]="FilterOptions.ALL" nzLabel="All" />
        <nz-option [nzValue]="FilterOptions.TRANSITIONS" nzLabel="Transitions" />
        <nz-option [nzValue]="FilterOptions.CHAT" nzLabel="Comments" />
        @if (additionalActivityLabel) {
          <nz-option [nzValue]="FilterOptions.ADDITIONAL" [nzLabel]="additionalActivityLabel" />
        }
      </nz-select>
    </div>

    <div class="flex flex-row items-end justify-center mt-16 mb-16 gap-16">
      <nz-form-item class="w-full mb-0 flex flex-col gap-4">
        @if (insertCommentTimestamp) {
          <div class="text-sm text-tertiary-text flex flex-row items-center gap-4 ml-2">
            Adding comment at {{ insertCommentTimestamp | twDate: 'MMM dd, HH:mm' }}
            <twaice-fe-svg-icon class="cursor-pointer" name="x" source="tabler" size="13px" (click)="insertComment(null)" />
          </div>
        }
        <textarea placeholder="Add a new note here" [(ngModel)]="newMessage" nz-input rows="1"></textarea>
      </nz-form-item>
      <nz-form-item class="mb-0 flex-[1_0_auto]">
        <button nz-button nzType="primary" [nzLoading]="submittingMessage" [disabled]="!newMessage" (click)="postMessage()">
          Send
        </button>
      </nz-form-item>
    </div>

    <div class="flex flex-col overflow-y-auto max-h-[320px] border-1 border-solid rounded-lg pt-24 pb-8 px-16">
      @for (timelineDay of timelineItems$ | async; track timelineDay.day) {
        <b class="text-sm mt-[-16px] mb-12">{{ timelineDay.day | twDate: 'MMM dd, yyyy' : storageTimezone }}</b>

        <nz-timeline>
          @for (timelineItem of timelineDay.items; track timelineItem.date) {
            <ng-template #dotTemplate>
              <twaice-fe-svg-icon [name]="timelineItem.icon" source="tabler" size="16px" />
            </ng-template>
            <nz-timeline-item nzColor="gray" [nzDot]="dotTemplate">
              @if (timelineItem.transition; as transition) {
                <div class="flex items-center gap-4 with-comment-button">
                  <nz-tag
                    class="flex items-center m-0"
                    [style.background-color]="transition.from.backgroundColor"
                    [style.border-color]="transition.from.borderColor"
                    [nzBordered]="true"
                  >
                    <twaice-fe-svg-icon
                      nz-icon
                      [name]="transition.from.stateIcon"
                      source="tabler"
                      [color]="transition.from.stateIconColor"
                      size="16px"
                    />
                    <span [style.color]="transition.from.textColor">{{ transition.from.stateLabel }}</span>
                  </nz-tag>

                  <div class="text-tertiary-text font-bold h-16 mt-[-2px]">→</div>

                  <nz-tag
                    class="flex items-center"
                    [style.background-color]="transition.to.backgroundColor"
                    [style.border-color]="transition.to.borderColor"
                    nzBordered
                  >
                    <twaice-fe-svg-icon
                      nz-icon
                      [name]="transition.to.stateIcon"
                      source="tabler"
                      [color]="transition.to.stateIconColor"
                      size="16px"
                    />
                    <span [style.color]="transition.to.textColor">{{ transition.to.stateLabel }}</span>
                  </nz-tag>

                  <span class="font-sm text-tertiary-text">{{ transition.date | twDate: 'MMM dd, HH:mm z' }}</span>

                  <twaice-fe-svg-icon
                    class="ml-8 text-tertiary-text cursor-pointer mt-[-2px] comment-button"
                    (click)="insertComment(transition.date)"
                    name="message-plus"
                    source="tabler"
                    size="16px"
                  />
                </div>
              }
              @if (timelineItem.message; as message) {
                <div class="flex flex-col gap-4">
                  <span class="font-sm">
                    {{ message.userMail }} <span class="text-tertiary-text">{{ message.timestamp | twDate: 'HH:mm' }}</span></span
                  >
                  <span class="font-sm">{{ message.message }}</span>
                </div>
              }
              @if (timelineItem.activity; as activity) {
                @if (activity.actor) {
                  <div class="flex flex-col gap-4">
                    <div class="flex items-center gap-12 font-sm">
                      <span>{{ activity.actor }}</span>
                      <span class="text-tertiary-text">{{ activity.date | twDate: 'HH:mm' }}</span>
                    </div>
                    <span class="font-sm"
                      ><b>{{ activity.title }}</b> {{ activity.detail }}
                      @if (activity.link; as link) {
                        @if (link.url) {
                          <a class="inline-flex items-center gap-4" [href]="link.url" target="_blank" rel="noopener noreferrer"
                            >{{ link.label }}<twaice-fe-svg-icon name="external-link" source="tabler" size="14px"
                          /></a>
                        } @else {
                          {{ link.label }}
                        }
                      }
                    </span>
                  </div>
                } @else {
                  <div class="flex items-center gap-12 font-sm">
                    <span>{{ activity.title }}</span>
                    <span class="text-tertiary-text">{{ activity.date | twDate: 'MMM dd, HH:mm z' }}</span>
                  </div>
                }
              }
            </nz-timeline-item>
          }
        </nz-timeline>
      }
      @if ((timelineItems$ | async)?.length) {
        @if (canShowMoreItems) {
          <div class="flex justify-center mt-[-16px]">
            <button nz-button nzType="link" (click)="showMoreItems()">Show More</button>
          </div>
        }
      } @else {
        <div class="flex justify-center items-center h-[100px] mb-16">
          <span class="text-sm text-tertiary-text">No activity found</span>
        </div>
      }
    </div>
  </div>
}
